'use strict'
import Masonry from 'masonry-layout';

const Grid = {
    init: function () {
        const elem = document.querySelector('.grid');
        if (elem) {
            let grid = null;
            if (window.matchMedia('screen and ( min-width: 1025px )').matches) {
                grid = new Masonry(elem, {
                    // options
                    itemSelector: '.c-card',
                    gutter: 24
                });
            } else {
                if (grid) {
                    grid.destroy();
                }
            }
        }
    }
}

export default Grid;